import React from 'react';
import { Route } from '../Routing/types';
import { DietSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';
import stepsSchema from './stepsSchema';
import { DIET_TYPES, DIET_MODES } from '../GoalSettings/consts';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/diet-settings/goalSettings/*',
    element: (
      <DietSettingsPage
        descendantRoutes={descendantRoutes}
        stepsSchema={stepsSchema}
        currentMainStep="goalSettings"
        dietTypes={DIET_TYPES}
        dietModes={DIET_MODES}
      />
    ),
    private: true,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
